import React from "react";
import { observer } from "mobx-react-lite";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import OrderTableColumnsType from "@/scenes/OrderManagement/enum/OrderTableColumnsType";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { getRenderableOrderTableColumns } from "../utils";

interface OrderTableColgroupProps {
    tab?: OrderTab;
}

const OrderTableColgroup: React.FC<OrderTableColgroupProps> = function (props) {
    const { tab } = props;
    const orderManageStore = useOrderManagementStore();

    //  单打操作列宽, 待发货、挂起tab因为有发货图标宽度为105，其他为75
    const quickOperationColumnWidth = tab === OrderTab.PENDING_SHIPMENT || tab === OrderTab.ON_HOLD ? 105 : 75;

    const columns = getRenderableOrderTableColumns(orderManageStore.storage.sortedColumns, tab);

    const cols = [];

    columns.forEach((column) => {
        const { type: key } = column;

        switch (key) {
            case OrderTableColumnsType.CHECKBOX:
                cols.push(<col key={key} width="32"></col>);
                break;

            case OrderTableColumnsType.STATUS:
                cols.push(<col key={key} width="75"></col>);
                break;
            case OrderTableColumnsType.SHOP_INFO:
                cols.push(<col key={key} width="75"></col>);

                break;

            case OrderTableColumnsType.ORIGINAL_ID:
                cols.push(<col key={key} width="180"></col>);
                break;

            case OrderTableColumnsType.RETAILER:
                cols.push(<col key={key} width="80"></col>);
                break;
            case OrderTableColumnsType.BUYER_USERNAME:
                cols.push(<col key={key} width="80"></col>);
                break;

            case OrderTableColumnsType.PAYMENTS:
                cols.push(<col key={key} width="60"></col>);
                break;

            case OrderTableColumnsType.QUANTITY:
                cols.push(<col key={key} width="40"></col>);
                break;
            case OrderTableColumnsType.SELLER_RECEIPTS:
                cols.push(<col key={key} width="60"></col>);
                break;

            case OrderTableColumnsType.PRODUCT:
                // 使用存储的自定义宽度或默认宽度190
                cols.push(<col key={key} width={orderManageStore.storage.columnWidthMap.get(key) || 190} />);
                break;

            case OrderTableColumnsType.CUSTOMIZATION_INFO:
                cols.push(<col key={key} width="200"></col>);
                break;
            case OrderTableColumnsType.SHIPPING_DEADLINE:
                cols.push(<col key={key} width="210"></col>);
                break;
            case OrderTableColumnsType.ORDER_TIME:
                cols.push(<col key={key} width="87"></col>);
                break;
            case OrderTableColumnsType.PAYMENT_TIME:
                cols.push(<col key={key} width="92"></col>);
                break;
            case OrderTableColumnsType.INVOICE_INFO:
                cols.push(<col key={key} width="130"></col>);
                break;
            case OrderTableColumnsType.CONSIGNEE:
                // CONSIGNEE 列不设置宽度，让其根据剩余空间自动调整
                cols.push(<col key={key}></col>);
                break;
            case OrderTableColumnsType.ORDER_REMARK:
                cols.push(<col key={key} width={orderManageStore.storage.columnWidthMap.get(key) || 160}></col>);
                break;
            case OrderTableColumnsType.SHIPPING_TIME:
                cols.push(<col key={key} width="87"></col>);
                break;

            case OrderTableColumnsType.WAYBILL_NO:
                cols.push(<col key={key} width="144"></col>);
                break;
            case OrderTableColumnsType.SUPPLIER_DROPSHIPPING2:
                cols.push(<col key={key} width="160"></col>);
                break;
            case OrderTableColumnsType.SEQUENCE_NO:
                cols.push(<col key={key} width="50"></col>);
                break;
            case OrderTableColumnsType.WEIGHT:
                cols.push(<col key={key} width="40"></col>);
                break;
            case OrderTableColumnsType.SHIPPER:
                cols.push(<col key={key} width="100"></col>);
                break;
            case OrderTableColumnsType.LOGISTICS_AGING_PREDICT:
                cols.push(<col key={key} width="100"></col>);
                break;

            case OrderTableColumnsType.LOGISTICS_RECOMMEND:
                cols.push(<col key={key} width="100"></col>);
                break;

            case OrderTableColumnsType.QUICK_OPERATION:
                cols.push(<col key={key} width={quickOperationColumnWidth}></col>);
                break;

            case OrderTableColumnsType.OPERATION:
                cols.push(<col key={key} width="85"></col>);
                break;

            default:
                break;
        }
    });

    return <colgroup>{cols}</colgroup>;
};

export default observer(OrderTableColgroup);
